import { t } from 'i18next';
import * as yup from 'yup';

import { PrevailingWageBenefit } from '~hooks/usePrevailingWageBenefits/models';

export const benefitSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(1, t('form_validation_errors.required_simple'))
    .required(t('form_validation_errors.required_simple')),
});

export type BenefitDto = yup.InferType<typeof benefitSchema>;
export type BenefitDtoAsyncError = {
  field: keyof BenefitDto;
  message: string;
};

export const setBenefitDefaultValues = (benefit?: PrevailingWageBenefit): BenefitDto => ({
  name: benefit?.name ?? '',
});
